import { combineReducers } from 'redux';
import serp from './Serp/reducer';
import adPage from './AdPage/reducer';
import index from './Index/reducer';
import alerts from './Alerts/reducer';
import notifications from './Notifications/reducer';
import trovit from './Index/reducerTrovit';
import config from './Index/reducerConfig';
import suggestions from './Suggestions/reducer';
import sources from './Sources/reducer';
import featuredAd from './FeaturedAd/reducer';
import notificationsManagerEmail from './NotificationsManager/email/reducer';
import notificationsManagerWebPush from './NotificationsManager/webPush/reducer';
import notificationsManagerSettings from './NotificationsManager/settings/reducer';
import feedback from './CaptureFeedback/reducer';
import gdpr from './Gdpr/reducer';

export default combineReducers({
  serp,
  suggestions,
  adPage,
  index,
  alerts,
  notifications,
  trovit,
  config,
  sources,
  featuredAd,
  notificationsManagerEmail,
  notificationsManagerWebPush,
  notificationsManagerSettings,
  feedback,
  gdpr,
});



// WEBPACK FOOTER //
// ./app/rootReducer.js